module.exports = __webpack_public_path__ + "static/img/压路机SCW.ca55195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/智能碰撞预警系统/压路机SCW.png
// module id = KbaC
// module chunks = 0